export default {
  async created() {
    const { hash } = window.location;

    const body = {
      companyId: this.$store.state.users.currentUser.company.id,
      perPage: 50,
    };
    await this.$store.dispatch('users/getCompanyUsers', body);

    this.defaultTab = hash.replace('#', '');
  },
  methods: {
    setHash(hash) {
      const { search } = window.location;

      window.history.pushState(null, null, `${search}#${hash}`);
    },
  },
};
